import React from 'react';
import { Button } from './ui/button';
import { X, BookOpen, Users, Clock, Star } from 'lucide-react';

const ModalMatricula = ({ 
  isOpen, 
  onClose, 
  curso, 
  onMatricular, 
  carregandoMatricula = false 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-red-600/20 rounded-full flex items-center justify-center">
              <BookOpen className="w-5 h-5 text-red-400" />
            </div>
            <h2 className="text-xl font-bold text-white">Matrícula Necessária</h2>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-colors p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Mensagem principal */}
          <div className="text-center space-y-3">
            <div className="w-16 h-16 bg-gradient-to-br from-red-600 to-red-700 rounded-full flex items-center justify-center mx-auto shadow-lg">
              <BookOpen className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-white">
              Para assistir este curso você precisa se matricular
            </h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              A matrícula é gratuita e você terá acesso completo a todo o conteúdo do curso.
            </p>
          </div>

          {/* Informações do curso */}
          {curso && (
            <div className="bg-slate-800/50 rounded-xl p-4 space-y-3">
              <h4 className="font-semibold text-white text-center">{curso.titulo}</h4>
              
              {curso.descricao && (
                <p className="text-slate-300 text-sm text-center line-clamp-3">
                  {curso.descricao}
                </p>
              )}

              <div className="flex items-center justify-center gap-6 text-xs text-slate-400">
                {curso.total_alunos !== undefined && (
                  <div className="flex items-center gap-1">
                    <Users className="w-3 h-3" />
                    <span>{curso.total_alunos} alunos</span>
                  </div>
                )}
                
                {curso.videos && curso.videos.length > 0 && (
                  <div className="flex items-center gap-1">
                    <BookOpen className="w-3 h-3" />
                    <span>{curso.videos.length} vídeos</span>
                  </div>
                )}

                {curso.duracao && (
                  <div className="flex items-center gap-1">
                    <Clock className="w-3 h-3" />
                    <span>{Math.floor(curso.duracao / 60)}h {curso.duracao % 60}min</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Benefícios */}
          <div className="space-y-2">
            <h5 className="font-medium text-white text-sm">O que você ganha com a matrícula:</h5>
            <ul className="space-y-2 text-sm text-slate-300">
              <li className="flex items-center gap-2">
                <Star className="w-3 h-3 text-green-400 flex-shrink-0" />
                <span>Acesso completo a todos os vídeos</span>
              </li>
              <li className="flex items-center gap-2">
                <Star className="w-3 h-3 text-green-400 flex-shrink-0" />
                <span>Acompanhamento do seu progresso</span>
              </li>
              <li className="flex items-center gap-2">
                <Star className="w-3 h-3 text-green-400 flex-shrink-0" />
                <span>Acesso vitalício ao conteúdo</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-slate-700 space-y-3">
          <Button
            onClick={onMatricular}
            disabled={carregandoMatricula}
            className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-medium py-3 text-sm transition-all duration-200"
          >
            {carregandoMatricula ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                <span>Matriculando...</span>
              </div>
            ) : (
              'Matricular-se Gratuitamente'
            )}
          </Button>
          
          <Button
            onClick={onClose}
            variant="ghost"
            className="w-full text-slate-400 hover:text-white hover:bg-slate-800/50 text-sm"
          >
            Talvez mais tarde
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalMatricula; 